import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import Router from 'services/router'
import 'services/configAxios'
import { store, history } from 'services/configureStore'
import Localization from 'components/Localization'
import 'assets/styles/global.scss'

ReactDOM.render(
  <Provider store={store}>
    <Localization>
      <Router history={history} />
    </Localization>
  </Provider>,
  document.getElementById('root'),
)
